module.exports = {
      id: "ic-gator-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-gator-usage",
      toString: function () {
        return this.url;
      }
    }